export const DEBT_CORE_TASK_ID = 5200;

export const DEBT_MODULE_TASK_IDS = {
  MUTUOS: 5202,
  QUOTATIONS: 5203,
  HEDGES: 5204,
  COVENANTS: 5205,
  CLOSING: 5206,
  MARKET: 5207,
  CONTRACT_AI: 5208,
  CATALOG: 5209,
} as const;

export type DebtModuleTaskId = typeof DEBT_MODULE_TASK_IDS[keyof typeof DEBT_MODULE_TASK_IDS];

export const DEBT_MODULE_TASK_ID_LIST: readonly DebtModuleTaskId[] = Object.values(DEBT_MODULE_TASK_IDS);

export type DebtModuleAccess = 'enabled' | 'locked' | 'hidden';

export const resolveDebtModuleAccess = (
  isModuleEnabled: boolean,
  isLockedModulesFeatureActive: boolean,
): DebtModuleAccess => {
  if (isModuleEnabled) return 'enabled';
  return isLockedModulesFeatureActive ? 'locked' : 'hidden';
};
